<template>
  <section id="pricing" class="relative">
    <img
      src="@images/landing-page/rounded-bars-2.svg"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute -translate-x-[10rem] translate-y-[20rem] scale-200 rotate-[150deg] opacity-20 md:-translate-x-[20rem] md:translate-y-10 md:scale-100 lg:-translate-x-[10rem]"
      loading="lazy"
    />

    <img
      src="@images/logo/vibeteams-logo.svg"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute end-0 bottom-56 translate-x-[10rem] scale-150 -scale-x-150 -rotate-[30deg] opacity-20 md:bottom-0 md:translate-x-[15rem] md:-translate-y-[15rem]"
      loading="lazy"
    />

    <div class="relative mx-auto max-w-[85rem] space-y-10 px-4 lg:space-y-20">
      <div class="space-y-10">
        <div class="z-auto space-y-3">
          <h2 class="text-center font-exo-bold text-5xl text-pretty uppercase lg:text-6xl">
            choose your <span class="bg-linear-to-r from-mauve-500 to-navy-blue-500 bg-clip-text text-transparent">vibe</span>
          </h2>
          <p class="text-center text-eerie-black-200">Pick your groove and let your AI squad do the heavy lifting.</p>
        </div>
      </div>

      <div class="grid grid-cols-1 justify-items-center gap-5 md:grid-cols-2 md:gap-6 lg:grid-cols-4 lg:gap-10">
        <VibePlanCard
          v-for="plan in plans"
          :key="plan.id"
          :name="plan.name"
          :price="plan.price"
          :description="plan.description"
          :features="plan.features"
        ></VibePlanCard>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import VibePlanCard from '@/components/landing/VibePlanCard.vue';
export default {
  name: 'ChooseVibe',
  components: {
    VibePlanCard,
  },
  props: {
    plans: {
      type: Array,
      required: true,
    },
  },
};
</script>
